import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import NotificationAlert from "react-notification-alert";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import classes from "../../assets/css/CustomerDetails.module.css";
import { AxiosAPiPost } from "AxiosAPi";
import { axiosCreate } from "../../axios";
function DeleteCustomerForm({
  fetchCustomersList,
  closeCustomerDeleteDialog,
  openDelete,
  deletedCustomerID,
}) {
  // Use to redirect to client list page after form submission //
  const history = useHistory();
  // Use to redirect to client list page after form submission //
  // Show notification popup //
  const notificationAlertRef = useRef(null);
  // Show notification popup //
  // Loading state //
  const [loadingDelete, setLoadingDelete] = useState(false);
  async function handleDeleteCustomer() {
    setLoadingDelete(true);
    await axiosCreate
      .post("/customers/delete", { ids: [deletedCustomerID] })
      .then((res) => {
        if (res.data.status === true) {
          fetchCustomersList();
          onAlertShow(res.data.message, "success");
          setTimeout(() => {
            setLoadingDelete(false);
            closeCustomerDeleteDialog();
          }, 1000);

          //   getAllClientList();
        }
      })
      .catch((err) => {
        if (err.response.data.message === "Invalid Token") {
          localStorage.clear();
          history.push("/login");
        }
        onAlertShow(err.response.data.errors[0].msg, "warning");
        setLoadingDelete(false);
      });
  }
  const onAlertShow = (message, type) => {
    let options = {};
    options = {
      place: "tr",
      message: message,
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 3,
    };
    notificationAlertRef.current.notificationAlert(options);
  };
  return (
    <div>
      <Dialog
        open={openDelete}
        onClose={closeCustomerDeleteDialog}
        PaperProps={{
          style: {
            backgroundColor: "#fadf9e",
          },
        }}
      >
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to delete this customer?
        </DialogTitle>
        <DialogActions>
          <button
            onClick={handleDeleteCustomer}
            className={classes["btn_success"]}
            type="button"
            disabled={loadingDelete}
          >
            {loadingDelete ? "Processing..." : "Yes"}
          </button>
          <button
            className={classes["btn_error"]}
            type="button"
            onClick={closeCustomerDeleteDialog}
          >
            No
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DeleteCustomerForm;
